import { Timestamp } from "firebase/firestore/lite";

export enum ActionType {
  Add = "add",
  View = "view",
  Edit = "edit",
}

export enum TemplateFields {
  Name = "name",
  Content = "content",
}

export interface CustomTemplate {
  id: string;
  appId: string;
  elementName: string;
  languageCode: string;
  templateType: TemplateType;
  category: string;
  content: string;
  footer?: string;
  example: string;
  header?: string;
  exampleHeader?: string;
  enableSample?: boolean;
  exampleMedia?: string;
  containerMeta: string;
  vertical: string;
  meta: string;
  data: string;
  image?: string;
  status: CustomTemplateStatus;
  selectedMedia?: DbCustomTemplateMedia;
  buttons?: CustomTemplateButton[];
  createdOn: string;
  modifiedOn: string;
}

export interface TemplateContainerMeta {
  addSecurityRecommendation: boolean;
  allowTemplateCategoryChange: boolean;
  appId: string;
  data: string;
  editTemplate: boolean;
  enableSample: boolean;
  sampleMedia: string;
  sampleText: string;
  header?: string;
  sampleHeader?: string;
  footer?: string;
  buttons?: CustomTemplateButton[];
}

export enum CustomTemplateStatus {
  Approved = "APPROVED",
  Rejected = "REJECTED",
  Pending = "PENDING",
  Failed = "FAILED",
}

export interface DbCustomTemplateMedia {
  url: string;
  handle_id: string;
  blur_hash: string;
  file_type: string;
  created_at: Timestamp;
}

export enum TemplateType {
  Text = "TEXT",
  Image = "IMAGE",
}

export enum VariableType {
  NAME = "Name",
  NUMBER = "Number",
}

export enum HeaderType {
  TEXT = "Text",
  IMAGE = "Image",
}

export interface TemplateRequest {
  appId: string;
  templateId?: string;
  elementName: string;
  languageCode: string;
  category: string;
  templateType: string;
  vertical: string;
  content: string;
  header?: string;
  exampleHeader?: string;
  footer?: string;
  example: string;
  exampleMedia?: string;
  enableSample: boolean;
  buttons?: CustomTemplateButton[];
  status?: CustomTemplateStatus;
}

export interface CustomTemplateButton {
  type: string;
  text: string;
  url?: string;
  phone_number?: string;
  example?: string[];
}

export enum ButtonType {
  QuickReply = "quick_reply",
  CallToAction = "call_to_action",
}

export enum ButtonActionType {
  VisitWebsite = "visit_website",
  CallPhone = "call_phone",
  Custom = "custom",
}

export enum TemplateButtonType {
  QuickReply = "QUICK_REPLY",
  URL = "URL",
  PhoneNumber = "PHONE_NUMBER",
}

export enum TemplateCategory {
  Marketing = "MARKETING",
  Utility = "UTILITY",
}
